import { createContext } from "react";

export const ContractorContext = createContext();